<div class="statistics flex justify-between">
  <div class="secure statistics__card">
    <div class="statistics__icon" inlineSVG="landing/shield.svg"></div>
    <div class="statistics__details">
      <h3 class="details__header" translate>Secure</h3>
      <p class="details__desc" translate="Enjoy Our Trusted Links"></p>
    </div>
  </div>

  <div class="visitors statistics__card">
    <div class="statistics__icon" inlineSVG="landing/visitors.svg"></div>
    <div class="statistics__details">
      <p class="details__desc" translate>Total Visitors</p>
      <h3
        class="details__header"
        [innerText]="
          landingPageDataService.details().numberOfVisitors + 1 | counterFormat
        "
      ></h3>
    </div>
  </div>
</div>
